import { Icon } from '@design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { useCountryCode } from '../../../hooks/useCountryCode';
import { DrawerFormType } from '../../../types/Purchasing';

type Props = {
  setVisibleForm?: (formType: DrawerFormType) => void;
};

export const ShippingSelector: React.FC<Props> = ({ setVisibleForm }) => {
  const { t } = useTranslation(['product', 'countries']);
  const [countryCode] = useCountryCode();

  return (
    <button
      className="block w-full cursor-pointer rounded-sm border border-divider/20 p-3 transition duration-300 hover:text-neutral-4 md:p-4"
      onClick={() => setVisibleForm && setVisibleForm('locale')}
      type="button"
    >
      <div className="flex items-center justify-between">
        {t('product:drawers.review.shippingSelection', {
          country: t(`countries:${countryCode}`),
        })}
        <Icon name="ic_chevron_right" />
      </div>
    </button>
  );
};
